export const OPTION_ALL_VALUE = 'all'
export const OPTION_NO_PARTNER_GROUP_VALUE = ''

const getOption = (label, value) => ({
  label,
  value: value !== undefined ? value : label,
})

export default getOption
